/**
 * 
 * @param {number} t 
 */
export const formatTime = function(t) {
    return t.toString(10).padStart(2, "0");
}

/**
 * 
 * @param {number} size 
 */
export const formatSize = function(size) {
    if (size<1024) return size + "B";
    if (size<1024*1024) return (size/1024).toFixed(2) + "KB";
    if (size<1024*1024*1024) return (size/1024/1024).toFixed(2) + "MB";
    return (size/1024/1024/1024).toFixed(2) + "GB";
}

export const createFormData = function (data) {
    const formdata = new FormData();
    for (let key in data) {
        formdata.append(key, data[key]);
    }
    return formdata;
}

/**
 * 
 * @param {string} timeString 
 */
export const safeParse = function(timeString) {
    return Date.parse(timeString.replace(/-/g, "/").replace(/\./g, "/"));
}

/** 判断某对象是否不为null也不为NaN */
export const isset = function (val) {
    return val != undefined && val != null && !(typeof val == 'number' && isNaN(val));
}

/** 深拷贝一个对象 */
export const clone = function (data) {
    if (!isset(data)) return null;
    // date
    if (data instanceof Date) {
        // @ts-ignore
        return new Date(data);
    }
    // array
    if (Array.isArray(data)) {
        const copy = new Array(data.length);
        for (let i = 0; i < data.length; i++) {
            copy[i] = clone(data[i]);
        }
        // @ts-ignore
        return copy;
    }
    // 函数
    if (data instanceof Function) {
        return data;
    }
    // object
    if (data instanceof Object) {
        const copy = {};
        for (let i in data) {
            copy[i] = clone(data[i]);
        }
        // @ts-ignore
        return copy;
    }
    return data;
}

/**
 * 抽取预渲染数据
 * @param {string} name
 */
export const getSSRdata = function(name) {
    const dom = document.querySelector(`[data-ssr=${ name }]`);
    const data = JSON.parse(window.atob(dom.innerHTML));
    if (process.env.NODE_ENV === 'development') {
        console.log(`ssr[${name}] =`, data);
    }
    return data;
}

/**
 * 滚动到指定元素
 * @param {HTMLElement} elm 
 */
export const scrollToElm = function(elm) {
    window.scrollTo({
        top: elm.offsetTop,
        behavior: "smooth"
    });
}

/**
 * 元素属性渐变
 * @param {Element} element 
 * @param {String} attr 
 * @param {String} afterValue 
 * @param {Number} time 
 * @returns 
 */
export const transitionAttr = function(element, attr, afterValue, time) {
    if (typeof window.getComputedStyle == "undefined") return;
    
    const beforeValue = window.getComputedStyle(element)[attr];
    // 本行2015-05-20新增，mac Safari下，貌似auto也会触发transition, 故要none下~
    element.style.transition = "none";
    element.style[attr] = afterValue;
    const targetValue = window.getComputedStyle(element)[attr];
    element.style[attr] = beforeValue;
    setTimeout(() => {
        element.style.transition = `${attr} ${time}ms`;
        element.style[attr] = targetValue;
    })
};

export const getReason = function(code, reasonMap = {}) {
    return {
        '-100': '帖子不存在或已删除',
        '-101': '帖子已经被锁定',
        '-200': '塔不存在或已被删除',
        '-201': '评论不存在或已被删除',
        '-202': '评论已经被锁定',
        ...reasonMap,
        1002: '发言过于频繁',
        1003: '权限不足',
        1004: '用户未登录',
    }[code] || '未知错误';
}


/**
 * @param {string} raw
 * @returns {string}
 */
export const parseText = function(raw, fullTag = false) {
    raw = raw
        .replace(/(\n<br>)/g, "<br>")
        .replace(/[\n\r]/g, "<br>");
    if (fullTag) {
        raw = raw
            .replace(/\[img\](.*)\[\/img\]/g, ($0, $1) => `<img style="max-height:200px" src="${$1}"></img>`);
    }
    return raw
        .replace(/\[size=([^\]]+)\](.*?)\[\/size\]/g, ($0, $1, $2) => `<font size="${$1}">${$2}</font>`)
        .replace(/\[font=([^\]]+)\](.*?)\[\/font\]/g, ($0, $1, $2) => `<font face="${$1}">${$2}</font>`)
        .replace(/\[color=([^\]]+)\](.*?)\[\/color\]/g, ($0, $1, $2) => `<font color="${$1}">${$2}</font>`)
        .replace(/\[url\](.*?)\[\/url\]/g, ($0, $1) => `<a href="${$1}" target="_blank">${$1}</a>`)
        .replace(/\[url=([^\]]+)\](.*?)\[\/url\]/g, ($0, $1, $2) => `<a href="${$1}" target="_blank">${$2}</a>`)
        .replace(/\[b\](.*?)\[\/b\]/g, ($0, $1) => `<b>${$1}</b>`)
        .replace(/\[i\](.*?)\[\/i\]/g, ($0, $1) => `<i>${$1}</i>`)
}

/**
 * 
 * @param {() => void} fn 
 * @param {number} wait 
 * @returns {() => void}
 */
export const throttle = function(fn, wait) {
    let pre = Date.now();
    return (...rest) => {
        const now = Date.now();
        if (now - pre >= wait) {
            fn(...rest);
            pre = now;
        }
    }
}
